/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAiUsageBilling extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAiUsageBilling");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAiUsageBilling.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAiUsageBilling>): BackgroundJobPayloadForPeriodicAiUsageBilling {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAiUsageBilling(), model);
        BackgroundJobPayloadForPeriodicAiUsageBilling.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAiUsageBilling>): BackgroundJobPayloadForPeriodicAiUsageBilling {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAiUsageBilling.newInstance(<BackgroundJobPayloadForPeriodicAiUsageBilling> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAiUsageBilling) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAiUsageBilling.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAiUsageBilling): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAiUsageBilling.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
